import { RootState } from '../..'

export const selectPlanGroupState = (state: RootState) => state.main.user.planGroup;

export const selectPlanGroup = (state: RootState) => state.main.user.planGroup.planGroup

export const selectPlanGroups = (state: RootState) => state.main.user.planGroup.planGroups
